// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zohwhuaajulzeeywlhwr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpvaHdodWFhanVsemVleXdsaHdyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ2MTk1OTIsImV4cCI6MjA2MDE5NTU5Mn0.z2mY8qiJf9rkNdVT3hwXXOlHPNG3auurbyRm3OGCT_I";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);